import { isTokenPersistable, PENDING_EMAIL_VERIFY_KEY } from "../../utils/session";

export const INSTITUTIONAL_PROFILE_KEY = "institutionalPendingProfile";

// The marker is bound to the actual authenticated session; a different sign-in
// or an expired token must never resume (or clear) another account's profile.
export const getInstitutionalProfile = () => {
  try {
    const user = JSON.parse(window.localStorage.getItem(INSTITUTIONAL_PROFILE_KEY));
    if (user?.id && user.isProfileComplete === false
      && isTokenPersistable(user.accessToken)
      && user.accessToken === window.localStorage.getItem("token")
      && String(user.id) === window.localStorage.getItem("userId")
      && window.localStorage.getItem("isProfileComplete") === "false") return user;
    window.localStorage.removeItem(INSTITUTIONAL_PROFILE_KEY);
  } catch (_) {
    window.localStorage.removeItem(INSTITUTIONAL_PROFILE_KEY);
  }
  return null;
};

export const saveInstitutionalProfile = (user) => {
  window.localStorage.setItem("token", user.accessToken);
  window.localStorage.setItem("userId", user.id);
  window.localStorage.setItem("isProfileComplete", "false");
  window.localStorage.removeItem(PENDING_EMAIL_VERIFY_KEY);
  // Do not leave the previous account's identity alongside the new token.
  window.localStorage.removeItem("role");
  window.localStorage.removeItem("userdetails");
  window.localStorage.setItem(INSTITUTIONAL_PROFILE_KEY, JSON.stringify(user));
};

export const clearInstitutionalProfile = () => {
  window.localStorage.removeItem(INSTITUTIONAL_PROFILE_KEY);
};

export const abandonInstitutionalProfile = (user) => {
  if (user && window.localStorage.getItem("token") === user.accessToken
    && window.localStorage.getItem("userId") === String(user.id)) {
    ["token", "userId", "isProfileComplete", "role", "userdetails"].forEach((key) => window.localStorage.removeItem(key));
  }
  try {
    const marker = JSON.parse(window.localStorage.getItem(INSTITUTIONAL_PROFILE_KEY));
    if (marker?.accessToken === user?.accessToken && marker?.id === user?.id) clearInstitutionalProfile();
  } catch (_) {
    clearInstitutionalProfile();
  }
};
